/* eslint-disable no-unused-vars */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaginationV2 } from 'src/types';
import * as thunks from './thunks';
import { GetRmaInventoryRequest, RmaInventoryItem } from './types';

type InitialState = {
  rmaInventoryItems: RmaInventoryItem[];
  isRmaInventoryLoading: boolean;
  meta: PaginationV2;
  filters: GetRmaInventoryRequest;
};

export const initialState: InitialState = {
  rmaInventoryItems: [],
  isRmaInventoryLoading: false,
  meta: {},
  filters: { search_by: 'current' }
};

const slice = createSlice({
  name: 'rma-inventory',
  initialState,
  reducers: {
    setFilters: (state, { payload }: PayloadAction<GetRmaInventoryRequest>) => {
      state.filters = { ...state.filters, ...payload };
    }
  },

  extraReducers(builder) {
    builder.addCase(
      thunks.getRmaInventoryThunk.fulfilled,
      (state, { payload }) => {
        state.rmaInventoryItems = payload?.originalData?.data || [];
        state.meta = payload?.originalData?.meta || {};
        state.isRmaInventoryLoading = false;
      }
    );

    builder.addCase(thunks.getRmaInventoryThunk.pending, (state) => {
      state.isRmaInventoryLoading = true;
    });

    builder.addCase(thunks.getRmaInventoryThunk.rejected, (state) => {
      state.isRmaInventoryLoading = false;
    });
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
